"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CamelCaseStyles = exports.ExpandStyles = void 0;
var debugAttributes = [
    '--color',
    '--textstyle',
];
/**
 * Output style object into a CSS key/value for use in Styled Components
 * @param styles
 * @param debug
 */
var ExpandStyles = function (styles, debug) {
    if (debug === void 0) { debug = false; }
    var styleArray = Object.keys(styles)
        .filter(function (attribute) {
        if (debug) {
            // Return all attributes in debug mode
            return true;
        }
        if (debugAttributes.indexOf(attribute) === -1) {
            // Don't return debug attributes when not in debug mode
            return true;
        }
        return false;
    })
        .map(function (attribute) {
        return attribute + ": " + styles[attribute] + ";";
    });
    return styleArray.join('');
};
exports.ExpandStyles = ExpandStyles;
/**
 * Convert style attribute names to camel case for use in React's style attribute
 * @param styles
 * @param debug
 */
var CamelCaseStyles = function (styles, debug) {
    if (debug === void 0) { debug = false; }
    var camelCaseStyles = {};
    Object.keys(styles)
        .filter(function (attribute) {
        if (debug) {
            // Return all attributes in debug mode
            return true;
        }
        if (debugAttributes.indexOf(attribute) === -1) {
            // Don't return debug attributes when not in debug mode
            return true;
        }
        return false;
    })
        .forEach(function (attribute) {
        var key = attribute;
        var matches = key.match(/-.{1,1}/g);
        if (matches && debugAttributes.indexOf(attribute) === -1) {
            matches.forEach(function (match) {
                key = key.replace(match, match.substr(1).toUpperCase());
            });
        }
        camelCaseStyles[key] = styles[attribute];
    });
    return camelCaseStyles;
};
exports.CamelCaseStyles = CamelCaseStyles;
